<template>
  <div class="list-container">
    <i class="fa fa-bars sidebar aux-sidebar" @click="toggleSidebar"></i>
    <h1 class="detail-title">Select A Data Source</h1>
    <div class="row">
      <div class="col-sm-3 col-xs-12">
        <report-wizard-navigation></report-wizard-navigation>
      </div>
      <div class="col-sm-9 col-xs-12">
        <entity-filter :data-list="indicatorDataSources" :searchable-fields="searchableFields" show-alphabetized-filter="false" :use-group="true" :group-by-options="groupByOptions">
        </entity-filter>
      </div>

    </div>
    <generic-report-table  :table-name="tableName" :title-map="titleMap" :table-body="indicatorDataSources" :end-point="endPoint"></generic-report-table>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import EntityFilter from '../EntityFilter';
import GenericReportTable from '../GenericReportTable';
import store from '../../store.js';
import constants from '../../constants.js';
import { ReportWizard } from '../../api.js'
import advancedSearchResults from '../advancedSearchResult';
import CreateCaption from '../CreateCaption';
import ReportWizardNavigation from './ReportWizardNavigation.vue';
import { bus } from '../../main';


export default {
  data() {
    return {
      titleMap: {
        'name': 'Name',
      },
      groupByOptions: {
        'name': 'Name',
      },
      tableName: constants.WIZARD_DATA_SOURCE,
      endPoint: '/data-sources',
      searchableFields: ['name'],
      label: 'Loading',
    };
  },
  computed:mapState({
      indicatorDataSources: state => state.indicatorDataSources,
      reportObject: state => state.reportObject
  }),
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    }
  },
  created () {
    let id = this.reportObject['indicator']
    store.dispatch('fetchIndicatorDataSources', { id });
  },
  components:{
    GenericReportTable,
    EntityFilter,
    advancedSearchResults,
    CreateCaption,
    ReportWizardNavigation
  }
};
</script>
<style lang="scss">
.tab-bar {
    margin-bottom: 0rem;
}
h1{
    height: 21px;
  }
  .list-container{
    height: 100%;
  }
  @media (max-width:720px){
    .list-container {
      color:white;

      .row .col-sm-9{
        display:none;
      }
    }
    .wizard-container .list-container h1{
      &.detail-title{
        background-color: #04bafc;
      }
      height:52px;
      line-height: 1;
      margin-bottom:0px;
      padding-left: 70px;
      padding-top: 10px;
    }
    .aux-sidebar{
      display: block;
      position: absolute;
      top: 10px;
      left: 31px;
      font-size: 150%;
    }
    .list-header{
      margin-top:10px;
    }
    .table-container{
      padding-top: 15px;
      min-height: 45vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/SelectDataSourceWizard.vue